<template>
  <v-select
    v-model="selectedItems"
    item-text="text"
    item-value="id"
    :items="items"
    :multiple="multiselect"
    :append-outer-icon="appendOuterIcon"
    :prepend-icon="prependIcon"
    persistent-hint
    :style="cssStyle"
    v-bind:label="label"
    :placeholder="placeholder"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="toggle">
        <v-list-item-action>
          <v-icon :color="selectedItems.length > 0 ? 'primary' : ''">{{ icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{$t('SelectAll')}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <span class="text-capitalize">{{getSelectionText(index, item)}}</span>
    </template>
  </v-select>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    multiselect: {
      type: Boolean,
      default: true
    },
    appendOuterIcon: {
      type: String,
      default: ""
    },
    prependIcon: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    cssStyle: {
      type: String,
      default: ""
    }
  },
  created() {
    this.selectedItems = this.items.map(function(item) {
      return item.id;
    });
  },
  data: () => ({
    selectedItems: []
  }),

  computed: {
    allItemsSelected() {
      return this.selectedItems.length === this.items.length;
    },
    someItemsSelected() {
      return this.selectedItems.length > 0 && !this.allItemsSelected;
    },
    icon() {
      if (this.allItemsSelected) return "mdi-close-box";
      if (this.someItemsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  methods: {
    setSelectedItems(selectedItems) {
      this.selectedItems = selectedItems || [];
    },
    getSelectedItems() {
      return this.selectedItems;
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allItemsSelected) {
          this.selectedItems = [];
        } else {
          this.selectedItems = this.items.map(function(item) {
            return item.id;
          });
        }
      });
    },
    getSelectionText(index, item) {
      if (index === 0) {
        if (this.selectedItems.length === 1) return item.text;

        if (this.selectedItems.length > 1 && this.selectedItems.length != this.items.length)
          return `${this.selectedItems.length} ${this.$t("Selected")}`;

        if (this.selectedItems.length === this.items.length) return this.$t("All");
      }
    }
  },
  watch: {
    selectedItems: function(val, oldVal) {
      this.$emit("on-selection-change", val);
    }
  }
};
</script>